import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import { ExternalLink } from "src/library/components/exports";

type PrivacyPolicyProps = {
  value: boolean;
  handleCheckboxChange: Function;
  style?: Object;
};

export default function PrivacyPolicy(props: PrivacyPolicyProps) {
  const { value, handleCheckboxChange, style } = props;

  return (
    <>
      <Typography
        variant="body1"
        fontWeight="fontWeightBold"
        textAlign="left"
        color="text.light"
        sx={{ mb: 1 }}
      >
        Consent to receive marketing communications:
      </Typography>
      <FormControlLabel
        sx={{ display: "flex", justifyContent: "flex-start", pl: 2, textAlign: "left" }}
        label={
          <Typography>
            {"I have read and accept the "}
            <ExternalLink
              link="https://hackathon.entaingroup.com.au/Privacy_Policy_v10_-_clean_2021.09.14.pdf"
              text="Entain Privacy Policy"
              style={{ color: "#0CD6FF" }}
            />
            {
              " which details the collection, use and storage of this information and will comply with Entain’s obligations under the Privacy Act 1988 (Cth)."
            }
          </Typography>
        }
        name="agreeReceiveEmail"
        control={
          <Checkbox
            name="agreeReceiveEmail"
            checked={value}
            sx={style}
            onChange={() => handleCheckboxChange("agreeReceiveEmail", !value)}
          />
        }
      />
    </>
  );
}
